import { VStack } from 'native-base';
import React from 'react';

import HTML from 'app/components/HTML';
import { AttractionContent } from 'app/hooks/useAttraction';

export type AttractionDetailsWhatsIncludedProps = {
  attraction: NonNullable<AttractionContent>;
};

export default function AttractionDetailsWhatsIncluded({
  attraction,
}: AttractionDetailsWhatsIncludedProps) {
  const admission = [...attraction.admission.map(({ value }) => value), attraction.exclusiveFeature]
    .filter(Boolean)
    .join('<br/><br/>');

  return (
    <VStack space="2" testID="AttractionDetailsWhatsIncluded">
      <HTML
        defaultTextProps={{
          selectable: true,
        }}
        html={admission}
      />
    </VStack>
  );
}
